import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper", {
      active: $setup.isShow
    }]),
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.goTop && $setup.goTop(...args))
  }, _cache[1] || (_cache[1] = [_createElementVNode("svg", {
    viewBox: "0 0 34 34"
  }, [_createElementVNode("use", {
    "xlink:href": "#go_to_top"
  })], -1)]), 2);
}